import { BrandLogo } from "@/components/shared/BrandLogo";

import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/properties", label: "Properties" },
  { to: "/careers", label: "Careers" },
];

export function PublicNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const portalTarget = user && user.role === "admin" ? "/admin" : user ? "/portal" : "/login";

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass border-b border-[var(--aur-border)]">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex h-20 items-center justify-between">
          <Link to="/" data-testid="nav-brand-logo">
            <BrandLogo />
          </Link>

          <nav className="hidden items-center gap-10 md:flex">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className={`link-underline font-sans text-sm tracking-wide transition-colors ${
                  pathname === l.to ? "text-gold" : "text-[var(--aur-text-2)] hover:text-[var(--aur-text)]"
                }`}
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="hidden items-center gap-4 md:flex">
            <button
              data-testid="nav-portal-btn"
              onClick={() => navigate(portalTarget)}
              className="flex items-center gap-2 rounded-full border border-gold/40 px-4 py-2 font-sans text-xs uppercase tracking-widest text-gold transition-all hover:bg-gold hover:text-[var(--aur-bg)]"
            >
              <User size={14} />
              {user ? (user.role === "admin" ? "Admin CRM" : "My Portal") : "Sign In"}
            </button>
            <button
              data-testid="nav-request-to-book"
              onClick={() => navigate("/properties")}
              className="rounded-full bg-gold px-5 py-2 font-sans text-xs font-semibold uppercase tracking-widest text-[var(--aur-bg)] transition-all hover:bg-gold-bright"
            >
              Request to Book
            </button>
          </div>

          <button className="md:hidden text-[var(--aur-text)]" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-[var(--aur-border)] bg-[var(--aur-bg)] px-6 py-6 md:hidden">
          <div className="flex flex-col gap-5">
            {links.map((l) => (
              <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="font-sans text-base text-[var(--aur-text-2)]">
                {l.label}
              </Link>
            ))}
            <button
              onClick={() => { setOpen(false); navigate(portalTarget); }}
              className="rounded-full border border-gold/40 px-4 py-2.5 text-left font-sans text-sm text-gold"
            >
              {user ? (user.role === "admin" ? "Admin CRM" : "My Portal") : "Sign In"}
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
